export enum OcktoStateType {
    start = 10,
    qrcodeScanned = 20,
    finished = 30,
    failed = 99
}
